<template>
    <div>
        <div class="panel">
            <div class="panel-heading">
                <div class="panel-title">
                    <span class="title">
                        <b>Novo Administrador</b>

                        <i class="fa fa-user-circle" style="float:right;margin-top:6px;font-size:21px;"></i>
                    </span>

                    <hr class="m-t-md">
                </div>
            </div>
            <div class="panel-body">
                <form id="form">
                    <div class="row">
                        <div class="col-md-4">
                            <input-text label="Nome" v-model="user.name"></input-text>
                        </div>
                        <div class="col-md-4">
                            <input-text label="E-mail" v-model="user.email" readonly="true"></input-text>
                        </div>
                        <div class="col-md-4">
                            <input-text label="Cargo" v-model="user.role" readonly="true"></input-text>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <label for="name">Senha</label>
                            <input type="password" class="form-control" name="password" v-model="user.password">
                        </div>
                        <div class="col-md-6">
                            <label for="password_confirmation">Confirmação de Senha</label>
                            <input type="password" class="form-control" name="password_confirmation"
                                   v-model="user.password_confirmation">
                        </div>
                    </div>

                    <hr>

                    <div class="block text-right">
                        <router-link to="/admin" class="btn btn-info m-r-sm">
                            <i class="fa fa-arrow-left"></i> Voltar
                        </router-link>
                        <a class="btn btn-success" @click="save">
                            Salvar <i class="fa fa-save"></i>
                        </a>
                    </div>
                </form>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                user: {
                    id: 0,
                    name: '',
                    email: '',
                    role: '',
                    password: '',
                    password_confirmation: ''
                },
                errors: undefined
            }
        },
        props: {},
        mounted: function () {
            const id = this.$route.params.id;
            const api = this.$store.state.api;
            const self = this;

            self.$http.get(api + 'user/' + id)
                .then((response) => {
                    const data = response.data;

                    this.user.id = data.id;
                    this.user.name = data.name;
                    this.user.email = data.email;
                })
        },
        methods: {
            save: function () {
                const api = this.$store.state.api;
                let self = this;

                self.$http.post(api + 'user/' + self.user.id, {
                    'id': self.user.id,
                    'name': self.user.name,
                    'email': self.user.email,
                    'password': self.user.password,
                    'password_confirmation': self.user.password_confirmation,
                    'role': self.user.role
                })
                .then((response) => {
                    self.users = response.data;
                    self.user = response.data;
                    this.tableData = self.users;

                    this.$message('Sucesso', 'Usuário atualizado com sucesso', 'success');

                })
                .catch((error) => {
                    this.errors = error.response.data.errors;
                    this.$message('Erro', 'Erro ao cadastrar', 'error');

                })
            }
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/Admin/Edit.vue